import { Outlet } from "react-router-dom";
import { Box, Toolbar, Typography } from "@mui/material";
import sizeConfigs from "../../configs/sizeConfigs";
import Sidebar from "../common/Sidebar";
import { useLocation } from "react-router-dom";
import FolderIcon from "@mui/icons-material/Folder";
import { useNavigate } from "react-router-dom";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import backgroundimage from "../../assets/images/backgroundimage.jpg";
import CookieConsent from "../../utils/CookieConsent";
import ChatBot from "../../pages/ChatBot/ChatBot";
import ChatBotIcon from "../../assets/images/chatBot1.png";
import { useState } from "react";

import Draggable from "react-draggable";




const colorConfigs = {
  sidebar: {
    bg: "#233044",
    color: "#eeeeee",
    hoverBg: "#1e293a",
    activeBg: "#1e253a",
  },
  topbar: {
    bg: "#fff",
    color: "#000",
  },
  mainBg: `url(${backgroundimage})`,
};

const MainLayout = () => {


  const [isHovered, setIsHovered] = useState(false);
  const [isChatBotOpen, setIsChatBotOpen] = useState(false);

  const location = useLocation();
  var menuarray = [];
  let navigate = useNavigate();

  if (localStorage.getItem("userdata") == null) {
    navigate("/");
  } else {
    const items2 = JSON.parse(localStorage.getItem("userdata")!);
    if (items2.length > 0) {


      // const items1 = [
      //   {
      //     menuName: "Master",
      //     path: "",
      //     menuId: 1,
      //     displayNo: 1,
      //     childMenu: [
      //       {
      //         menuId: 2,
      //         menuName: "Zone Master",
      //         path: "/master/ZoneMaster",
      //         displayNo: 0,
      //       },
      //       {
      //         menuId: 4,
      //         menuName: "Department Master",
      //         path: "/master/DepartmentMaster",
      //         displayNo: 0,
      //       },
      //       {
      //         menuId: 5,
      //         menuName: "Designation Master",
      //         path: "/master/DesignationMaster",
      //         displayNo: 0,
      //       },
      //       {
      //         menuId: 7,
      //         menuName: "Country Master",
      //         path: "/master/CountryMaster",
      //         displayNo: 0,
      //       },
      //       {
      //         menuId: 8,
      //         menuName: "State Master",
      //         path: "/master/StateMaster",
      //         displayNo: 0,
      //       },
      //       {
      //         menuId: 9,
      //         menuName: "District Master",
      //         path: "/master/CityMaster",
      //         displayNo: 0,
      //       },
      //       {
      //         menuId: 13,
      //         menuName: "Item Status",
      //         path: "/master/ItemStatus",
      //         displayNo: 0,
      //       },
      //       {
      //         menuId: 14,
      //         menuName: "Area Master",
      //         path: "/master/AreaMaster",
      //         displayNo: 0,
      //       },
      //       {
      //         menuId: 15,
      //         menuName: "Item Type",
      //         path: "/master/ItemType",
      //         displayNo: 0,
      //       },
      //       {
      //         menuId: 16,
      //         menuName: "Tax Master",
      //         path: "/master/Taxmaster",
      //         displayNo: 0,
      //       },
      //       {
      //         menuId: 17,
      //         menuName: "Unit Master",
      //         path: "/master/Unitmaster",
      //       },
      //       {
      //         menuId: 18,
      //         menuName: "Store Master",
      //         path: "/master/Storemaster",
      //         displayNo: 0,
      //       },
      //       {
      //         menuId: 19,
      //         menuName: "Vendor Master",
      //         path: "/master/VendorMaster",
      //         displayNo: 0,
      //       },
      //       {
      //         menuId: 21,
      //         menuName: "Stock Ledger",
      //         path: "/master/Stockledger",
      //         displayNo: 0,
      //       },
      //       {
      //         menuId: 15,
      //         menuName: "Jurisdiction",
      //         path: "/master/Jurisdiction",
      //         displayNo: 0,
      //       },
      //     ],
      //   },
      //   {
      //     menuName: "User Mgmt",
      //     path: "",
      //     menuId: 3,
      //     displayNo: 1,
      //     childMenu: [
      //       {
      //         menuId: 1,
      //         menuName: "User Management",
      //         path: "/UserManagement/UserManagement",
      //         displayNo: 0,
      //       },
      //       {
      //         menuId: 2,
      //         menuName: "Role Master",
      //         path: "/UserManagement/RoleMaster",
      //         displayNo: 0,
      //       },
      //       {
      //         menuId: 3,
      //         menuName: "User Type",
      //         path: "/UserManagement/UserType",
      //         displayNo: 0,
      //       },
      //       {
      //         menuId: 4,
      //         menuName: "User Permission Master",
      //         path: "/UserManagement/UserPermissionMaster",
      //         displayNo: 0,
      //       },
      //     ],
      //   },
      //   {
      //     menuName: "Employee",
      //     path: "",
      //     menuId: 4,
      //     displayNo: 1,
      //     childMenu: [
      //       {
      //         menuId: 1,
      //         menuName: "Employee Master",
      //         path: "/Employee/EmployeeMaster",
      //         displayNo: 0,
      //       },
      //     ],
      //   },
      //   {
      //     menuName: "Complaint Master",
      //     path: "complaintmaster",
      //     menuId: 5,
      //     displayNo: 1,
      //     childMenu: [
      //       {
      //         menuId: 1,
      //         menuName: "Complaint Assign",
      //         path: "/complaintmaster/ComplainAssignMaster",
      //         displayNo: 0,
      //       },
      //       {
      //         menuId: 2,
      //         menuName: "Complaint",
      //         path: "/complaintmaster/ComplaintMaster",
      //         displayNo: 0,
      //       },



      
      //       {
      //         menuId: 2,
      //         menuName: "Role Master",
      //         path: "/UserManagement/RoleMaster",
      //         displayNo: 0,
      //       },
      //     ],
      //   },
      // ]
      const items1 = items2[0]["userPermission"][0]["parentMenu"];
      //{id: 1, name: 'Master', label: 'Master', displayNo: 1, path: '', …}
      console.log('items2',items2)

      for (let index = 0; index < items1.length; index++) {
        const element = items1[index];

        var childmenuarray = [];
        var childMenu = items1[index]["childMenu"];

        for (let index2 = 0; index2 < childMenu.length; index2++) {
          childmenuarray.push({
            id: childMenu[index2]["menuId"],
            name: childMenu[index2]["menuName"],
            label: childMenu[index2]["menuName"],
            path: childMenu[index2]["path"],
            displayNo: childMenu[index2]["displayNo"],
            Icon: TouchAppIcon,
            onClick,
          });
        }
        menuarray.push({
          id: items1[index]["menuId"],
          name: items1[index]["menuName"],
          label: items1[index]["menuName"],
          displayNo: items1[index]["displayNo"],
          path: "",
          Icon: FolderIcon,
          items: childmenuarray.sort(
            (a: any, b: any) => a.displayNo - b.displayNo
          ),
        });
      }
    } else {
      navigate("/");
    }
  }

  const items = menuarray.sort((a, b) => a.displayNo - b.displayNo);

  function onClick(e: any, item: any) {
    console.log("Main " + item);

    let path = item.path;
    // if (path == "" || path == null || path == "undefind") {
    //   window.alert("Path Not Found ????");
    // } else {
    //   navigate(path);
    // }
  }
  return (
    <div>
      {location.pathname == "/" ? (
        <Outlet />
      ) : (
        <div>
          <Box sx={{ display: "flex" }}>
            <Sidebar items={items} />

            <Box
              // component="main"
              sx={{
                flexGrow: 1,
                px: 5,
                py: 3,
                width: `calc(100% - ${sizeConfigs.sidebar.width})`,
                // width:"100vh",
                minHeight: "100vh",
                backgroundColor: `var( --main-background)`,
                backgroundImage: `var(--background-image)`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                // backgroundImage: "url('../../assets/images/backgroundimage.jpg')"
              }}
            >
              <Toolbar />
              <Outlet />


              <Draggable>
              <Box
                sx={{
                  position: "fixed",
                  bottom: 20,
                  right: 20,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {isHovered && (
                  <Typography
                    variant="body2"
                    sx={{
                      marginRight: 1,
                      background: "rgba(0, 0, 0, 0.7)",
                      color: "white",
                      padding: "5px 10px",
                      borderRadius: "5px",
                      position: "absolute",
                      bottom: "70px", // Adjust as needed
                      right: "50px", // Adjust as needed
                    }}
                  >
                    Ask Me...
                  </Typography>
                )}
                <Box
                  component="img"
                  src={ChatBotIcon}
                  alt="Chatbot"
                  sx={{
                    width: 70,
                    height: 70,
                    cursor: "pointer",
                    "&:hover": {
                      opacity: 0.8,
                    },
                  }}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  onClick={() => setIsChatBotOpen(true)} // Open chatbot modal
                />
              </Box>

              </Draggable>
            </Box>

            
          </Box>


          <CookieConsent />


          <ChatBot
            open={isChatBotOpen}
            onClose={() => setIsChatBotOpen(false)}
          />
      
        </div>
      )}
    </div>
  );
};

export default MainLayout;
